import { Modal, ModalProps } from 'antd';
import CustomButton from '../buttons/CustomButton';
import './ModalConfirm.scss';
import SvgIconError from '../@svg/SvgIconError';

interface customModalProps extends ModalProps {
  className?: string;
  isOpen: boolean;
  setIsOpen?: (value: boolean) => void;
  handleCancelModal?: () => void;
  handleSubmitDel?: () => void;
  textCancel?: string;
  textSubmit?: string;
  disabled?: boolean;
  loading?: boolean;
  confirmRequest?: React.ReactNode;
  description?: React.ReactNode;
}

const ModalConfirm = (props: customModalProps) => {
  const {
    isOpen,
    setIsOpen,
    className,
    handleCancelModal,
    handleSubmitDel,
    title,
    textCancel,
    textSubmit,
    disabled,
    loading,
    confirmRequest,
    description,
    ...restProps
  } = props;

  return (
    <Modal
      className={`confirm-models ${className}`}
      open={isOpen}
      onCancel={handleCancelModal}
      closeIcon={false}
      {...restProps}
      footer={[]}
    >
      {confirmRequest}
      <div className="title">
        <SvgIconError />
        <span>{title}</span>
      </div>
      {description}
      <div className="btn-wrap">
        {textCancel && (
          <CustomButton onClick={handleCancelModal} className="custom-button__cancel">
            {textCancel}
          </CustomButton>
        )}
        {textSubmit && (
          <CustomButton
            className="custom-button__submit"
            onClick={handleSubmitDel}
            disabled={disabled}
            loading={loading}
          >
            {textSubmit}
          </CustomButton>
        )}
      </div>
    </Modal>
  );
};

export default ModalConfirm;
